import React from 'react';
import { Text, TextProps } from 'react-native';

/** Rough width of one character as a share of the font size: Bengali letters are wider than Latin ones. */
function charWidth(text: string, bold: boolean) {
  return /[ঀ-৿]/.test(text) ? 0.78 : bold ? 0.58 : 0.52;
}

/**
 * A single line that shrinks its font to fit `width` (never below `min`), then truncates with "…".
 * Cards use it so a long name makes the text smaller instead of making the card bigger. The size is
 * worked out from the text length, so it is the same on every platform (adjustsFontSizeToFit is not).
 */
export function FitText({ width, base, min = 11, bold = true, style, children, ...rest }: TextProps & { width: number; base: number; min?: number; bold?: boolean; children: string }) {
  const text = String(children ?? '');
  const per = charWidth(text, bold);
  const size = Math.max(min, Math.min(base, Math.floor(width / Math.max(1, text.length * per))));
  return (
    <Text {...rest} numberOfLines={1} style={[style, { fontSize: size, lineHeight: Math.round(size * 1.3) }]}>
      {text}
    </Text>
  );
}
